import React, { useRef } from "react";
import clsx from "clsx";
import { PIN_LENGTH } from "../../auth/authConstants";

/**
 * Reusable PIN entry field: `length` single-digit boxes with auto-advance,
 * backspace-to-previous, numeric-only input and an optional shake animation.
 * Controlled: value (array of chars), onChange, onComplete(pinString), shake.
 */
const PinInput = ({ value, onChange, onComplete, shake = false, autoFocus = false, length = PIN_LENGTH }) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const digit = e.target.value.replace(/\D/g, "").slice(-1);
    const next = [...value];
    next[index] = digit;
    onChange(next);

    if (digit && index < length - 1) inputRefs.current[index + 1]?.focus();
    if (next.every((d) => d !== "")) onComplete?.(next.join(""));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && value[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-2.5">
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          maxLength="1"
          className={clsx("pin-box", shake && "pin-box-error animate-shake")}
          value={value[index] ?? ""}
          autoFocus={autoFocus && index === 0}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputRefs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default PinInput;
